import { fetchWithAuth } from '../api/backendApi';
import { toast } from 'react-toastify';

/**
 * Create a new user document in Firestore if it doesn't exist
 * @param {Object} user - Firebase Auth user object
 * @returns {Promise<void>}
 */
export const createUserIfNotExists = async user => {
  if (!user) {
    console.log('No user provided to createUserIfNotExists');
    return null;
  }

  try {
    await fetchWithAuth('/api/v2/users/me', 'GET', null, {
      authUser: user,
      silent: true,
      suppressErrorLog: true,
      suppressRequestLog: true,
      suppressResponseLog: true,
    });
    return true;
  } catch (error) {
    console.error(`Error in createUserIfNotExists for ${user.uid}:`, error);
    return false;
  }
};

/**
 * Get user data from Firestore
 * @param {string} uid - User ID
 * @returns {Promise<Object|null>} - User data or null if not found
 */
export const getUserData = async (uid, authUser = null) => {
  if (!uid) {
    console.log('No uid provided to getUserData');
    return null;
  }

  try {
    const res = await fetchWithAuth('/api/v2/users/me', 'GET', null, {
      authUser,
      suppressErrorLog: true,
      suppressRequestLog: true,
      suppressResponseLog: true,
    });
    return res?.data || null;
  } catch (error) {
    console.error(`Error getting user data for ${uid}:`, error);
    return null;
  }
};

/**
 * Update user data in Firestore
 * @param {string} uid - User ID
 * @param {Object} data - User data to update
 * @returns {Promise<boolean>} - Success status
 */
export const updateUserData = async (uid, data) => {
  if (!uid || !data) {
    console.log('Invalid arguments to updateUserData', { uid, data });
    return false;
  }

  console.log(`Updating user data for ${uid}:`, data);
  toast.error('Updating user profile is not supported via API yet');
  return false;
};
